var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'font-weight-medium full-width bottom black': true,
    'small-letter-spacing': true,
    'text-xs': _vm.$vuetify.breakpoint.smAndDown,
    'text-md': _vm.$vuetify.breakpoint.mdAndUp,
  }},[_c('transition',{attrs:{"name":_vm.transition_name,"mode":"out-in"}},[_c('div',{key:_vm.refresh_key},[_vm._v(_vm._s(_vm.legal_text[_vm.legal_index].text))])]),_c('repetitive-signal',{key:"duration",attrs:{"ready":_vm.ready_duration,"milliseconds":_vm.duration},on:{"repetitive-signal-over":_vm.onDurationEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }